import { Component, OnInit, EventEmitter } from '@angular/core';
import { CoverIndexService } from '../../services/coverindex.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Sharedservice } from './../../shared-components/shared.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { UploadFile, UploaderOptions, UploadInput, UploadOutput } from 'ngx-uploader';
import { environment } from '../../../environments/environment';
import { ScheduleService } from '../../services/schedule.service';
import { AdjustmentService } from '../../services/adjustment.service';
import { AdjustmentModel } from '../../models/adjustment.model';
import { ScheduleModel } from '../../models/schedule.model';
import { severitymessage, LanguageConstants } from '../../shared-components/constant';
import { saveAs } from 'file-saver';
import { InfraService } from 'src/app/services/infra.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { EngagementService } from 'src/app/services/engagement.service';
import { EngagementModel } from 'src/app/models/engagement.model';
import { DatabookVersionEnum } from '../../enums/databook-version.enum';
import { BusinessTemplate } from '../../enums/business-template.enum';

@Component({
  standalone: false,
  selector: 'app-databook',
  templateUrl: './databook.component.html',
  styleUrls: ['./databook.component.css']
})
export class DatabookComponent implements OnInit {
  options: UploaderOptions;
  uploadInput: EventEmitter<UploadInput>;
  sourceFiles: UploadFile[];
  dragOver: boolean;
  databook: any;
  downloadenable = false;
  activeAccordion: number[];
  private configUrl: string;
  loadspinner = false;
  engagementId = +this.route.snapshot.paramMap.get('id');
  fileName: string;
  langCode: string;
  currLangTranslation: any;
  adjustments: AdjustmentModel[];
  selectedIds: any[] = [];
  SelectedAdjustment: any;
  files: ScheduleModel[] = [];
  scheduleselected: any;
  uploaddatabook = false;
  versionType = 1;
  templateId = 1;

  constructor(private infraService: InfraService, private coverIndexService: CoverIndexService, private route: ActivatedRoute,
    public sharedService: Sharedservice, private router: Router, private messageService: MessageService,
    private confirmationService: ConfirmationService, private Schedule: ScheduleService, private Adjustment: AdjustmentService,
    private translateService: TranslateService, private engagementService: EngagementService) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'filedownload/dataBook/' + this.engagementId;
    });
    this.options = { concurrency: 1, maxUploads: 1 };
    this.sourceFiles = [];
    this.uploadInput = new EventEmitter<UploadInput>();
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
    });
    this.sharedService.CheckUserAccessForEngagement(this.engagementId);
    this.route.params.subscribe(param => { param['src'] === 'selectadjustment' ? this.activeAccordion = [] : this.activeAccordion = [1]; });
    this.getDatabookstatus();
  }

  private getMyAdjustments(): void {
    this.Adjustment.getAdjustments(Number(this.engagementId))
      .subscribe((data: AdjustmentModel[]) => {
        this.adjustments = data;
        const SelectedAdjustment = this.adjustments.filter(w => w.isSelected === true);
        this.SelectedAdjustment = SelectedAdjustment.length;
      });
  }

  onUploadOutput(output: UploadOutput): void {
    if (output.type === 'allAddedToQueue') {
      const event: UploadInput = {
        type: 'uploadAll',
        url: this.coverIndexService.configUrl + '/upload/' + this.engagementId,
        method: 'POST',
        data: { foo: 'bar' },
        headers: {
          'Authorization': 'Bearer ' + (environment.isBearerAuthorizationEnabled ?
            localStorage['dbamsaltoken'] : environment.sampleToken)
        }
      };
      this.uploadInput.emit(event);
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
      this.sourceFiles.push(output.file);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      // update current data in files array for uploading file
      const index = this.sourceFiles.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.sourceFiles[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.sourceFiles = this.sourceFiles.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
  }

  updateCoverIndex() {
    this.loadspinner = true;
    const engBody = {
      engagementName: this.sharedService.activeEngagementName,
      paceId: this.sharedService.activePaceId
    };
    this.coverIndexService.updateCoverIndex(this.engagementId, engBody).subscribe(data => {
      this.loadspinner = false;
      this.confirmationService.confirm({
        message: this.currLangTranslation.databookComponentmessage.SuccessMessage.DatabookExport,
        header: this.currLangTranslation.labels.confirmation,
        acceptLabel: this.currLangTranslation.actionButtons.yes,
        rejectLabel: this.currLangTranslation.actionButtons.no,
        accept: () => {
          this.getDatabookstatus();
          this.downloadenable = true;
          this.downloadDatabook();
        },
        reject: () => {
          this.getDatabookstatus();
        }
      });
    }, error => {
      this.loadspinner = false;
    }
    );
  }

  // Downloads Databook from Blob Store.
  downloadDatabook() {
    if (this.downloadenable) {
      this.loadspinner = true;
      let apiService;
      if (this.versionType !== DatabookVersionEnum.PowerPivot) {
        apiService = this.coverIndexService.downloadDatabookFromBlob(this.engagementId);
      } else {
        apiService = this.coverIndexService.downloadPowerPivotDatabookFromBlob(this.engagementId);
      }

      apiService.subscribe(blobdata => {
        this.loadspinner = false;
        if (blobdata) {
          if (this.versionType === DatabookVersionEnum.PowerPivot) {
            let downloadFileName = this.fileName+'_Databook_';
            const today = new Date();
            let todayDateString;
            if (this.templateId === BusinessTemplate.Americas) {
              todayDateString = ('0' + (today.getMonth() + 1)).slice(-2) + ('0' + today.getDate()).slice(-2) + today.getFullYear();
              downloadFileName += `${todayDateString}.zip`;
            } else {
              todayDateString = ('0' + today.getDate()).slice(-2) + ('0' + (today.getMonth() + 1)).slice(-2) + today.getFullYear();
              downloadFileName += `${todayDateString}.zip`;
            }
            saveAs(blobdata, downloadFileName);
          } else {
            saveAs(blobdata, this.fileName);
          }
        }
      },
        error => {
          this.loadspinner = false;
          this.downloadenable = false;
          this.messageService.add({
            key: severitymessage.key, severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.DownloadError,
            sticky: true,
            closable: true
          });
        }
      );
    }
  }

  getDatabookstatus() {
    this.engagementService.getEngagement(this.engagementId)
      .subscribe((data: EngagementModel) => {
        this.coverIndexService.getDatabookstatus(this.engagementId, data.IsDynamicDatabook).subscribe(data => {
          this.databook = data;
          if (this.databook.length >= 1) {
            if (this.databook[0].IsProcessed >= 1) {
              this.versionType = this.databook[0].DatabookVersion;
              if (this.versionType === DatabookVersionEnum.PowerPivot) {
                this.fileName = this.databook[0].EngagementName;
              } else {
                const databookIndex = this.databook[0].DataBookName.lastIndexOf('\\');
                this.fileName = this.databook[0].DataBookName.substr(databookIndex + 1);
              }
              this.templateId = this.databook[0].TemplateId;
              this.uploaddatabook = false;
              this.downloadenable = true;
            } else {
              this.uploaddatabook = true;
              this.downloadenable = false;
            }
          }
        });
      });
  }
}
